// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"Xjyf3wABt_2FxU6AEhz2"};